import React, { useState, useEffect, useContext } from 'react';
import { QueryContext } from '../../../hooks/Contexts';

function determineSort(sortParam) {
  let id, direction;
  if (sortParam) {
    id = sortParam.split('.')[0];
    direction = sortParam.split('.')[1];
    return { id, direction };
  }
  return { id: 'id', direction: 'desc' };
}

const translateDirection = (dir) =>
  dir === 'desc' ? 'down' : dir === 'asc' ? 'up' : '';

const SorterIcon = ({ handleSort, id }) => {
  const { queryParams } = useContext(QueryContext);
  const activeSort = determineSort(queryParams?.sort);
  const idString = id.toString();
  const isActive = activeSort.id === idString;
  const [direction, setDirection] = useState(
    isActive ? translateDirection(activeSort.direction) : ''
  );

  useEffect(() => {
    if (isActive) setDirection(translateDirection(activeSort.direction));
  }, [activeSort]);

  function handleChange(e) {
    let newDirection;
    if (direction && isActive) {
      newDirection = direction === 'down' ? 'up' : 'down';
    } else {
      newDirection = 'down';
    }
    setDirection(newDirection);
    handleSort(e, idString, newDirection);
  }

  return (
    <span id={idString} className='sorter'>
      <i
        className={`fa-solid fa-sort` + (isActive ? `-${direction}` : '')}
        onClick={(e) => handleChange(e)}
      />
    </span>
  );
};

export default SorterIcon;
